import { ref as l } from "vue";
function a() {
  const o = l(!1);
  function i(e) {
    o.value = e === void 0 ? !o.value : e;
  }
  return {
    isDialogVisible: o,
    setIsDialogVisible: i
  };
}
export {
  a as useRDialog
};
